import React, { useCallback } from "react";
import { Flex, Text, Em, Button, Spinner } from "@radix-ui/themes";
import { PersonIcon } from "@radix-ui/react-icons";
import { ErrorMessage } from "../../entities/Message";

export function ErrorMessageComponent({
  text,
  data: { errorType },
  onEscalate,
}: ErrorMessage & { onEscalate: () => Promise<void> }) {
  const [isEscalating, setIsEscalating] = React.useState(false);

  const handleEsclate = useCallback(async () => {
    setIsEscalating(true);
    await onEscalate();

    setIsEscalating(false);
  }, [onEscalate]);

  return (
    <Flex
      px={"12px"}
      py={"8px"}
      direction={"column"}
      gap={"5"}
      style={{ backgroundColor: "var(--gray-2)", borderRadius: "8px" }}
    >
      <Text size={"2"} color={"gray"}>
        <Em>{text}</Em>
      </Text>

      {errorType === "ai_failed" && (
        <Flex gap={"2"}>
          <Button
            size={"1"}
            color={"gray"}
            variant={"outline"}
            onClick={handleEsclate}
            disabled={isEscalating}
            aria-label="Escalate to agent"
          >
            <Spinner loading={isEscalating}>
              <PersonIcon />
            </Spinner>
            Contact an Agent
          </Button>
        </Flex>
      )}
    </Flex>
  );
}
